import { loggedUser } from "../../../Constants/menus";
import { routers } from "../../../Constants/routers";

const isSearch = window.location.pathname === "/search";

/* eslint-disable no-undef */
window.handleChange = (e) =>{
  console.log(e.target.value)
}

export const rawHeader = ({ isHome = false, isLoggedIn = true, hideSearch, profile = {} }) => {

  const getAudienceBox = () => {
    return (`
      <div class="type-block">
        <div class="meta">
          <span>Free Consultation</span>
          <span>Show specialist with online consultation</span>
        </div>
        <div class="action">
          <label class="form-switch is-primary">
            <input
              type="checkbox"
              name="search_type_radio"
              class="is-switch search-filter-option"
              data-name="freeConsult"
            />
            <i></i>
          </label>
        </div>
      </div>
      <div class="type-block">
        <div class="meta">
          <span>Online Consultation</span>
          <span>Show specialist with online consultation</span>
        </div>
        <div class="action">
          <label class="form-switch is-primary">
            <input
              type="checkbox"
              name="search_type_radio"
              class="is-switch search-filter-option"
              data-name="onlineConsult"
            />
            <i></i>
          </label>
        </div>
      </div>
      <div class="type-block">
        <div class="meta">
          <span>Home Service</span>
          <span>Show specialist with home service options</span>
        </div>
        <div class="action">
          <label class="form-switch is-primary">
            <input
              type="checkbox"
              name="search_type_radio"
              class="is-switch search-filter-option"
              data-name="homeService"
            />
            <i></i>
          </label>
        </div>
      </div>
      <div class="type-block">
        <div class="meta">
          <span>Elders Checkup</span>
          <span>Show specialist that can visit my elder ones</span>
        </div>
        <div class="action">
          <label class="form-switch is-primary">
            <input
              type="checkbox"
              name="search_type_radio"
              class="is-switch search-filter-option"
              data-name="eldersCheckup"
            />
            <i></i>
          </label>
        </div>
      </div>
    `)
  }

  return (
    `<div
${ isHome
		? `
class="main-navigation"
data-x-data="initNavbar()"
data-x-on:scroll.window="scroll()"
data-x-on:mouseleave="megamenuOpened = false"
data-x-bind:class="{
    'is-scrolled': scrolled,
    '': !scrolled,
    'is-expanded': searchExpanded,
    '': !searchExpanded,
    'is-solid': megamenuOpened,
    '': !megamenuOpened,
}"
`
		: `class="main-navigation is-scrolled"
data-x-on:mouseleave="megamenuOpened = false"
data-x-on:mouseenter="megamenuOpened = true"
data-x-data="initNavbar()"
data-x-on:click.away="megamenuOpened = false"
data-x-bind:class="{
      'is-expanded': searchExpanded,
      '': !searchExpanded,
      'is-solid': megamenuOpened,
      '': !megamenuOpened,
  }"
`
}

>
<div class="main-navigation--menu">
  <div class="container">
    <div class="main-navigation--menu-inner">
      <div class="left">
        <a href="/" class="brand">
          <img class="light-logo" src="${ window.innerWidth < 900 ? require("../../../assets/images/logo.png").default : require("../../../assets/images/logo.png").default}" alt="" />
          <img class="dark-logo" src="${window.innerWidth < 900 ? require("../../../assets/images/logo.png").default : require("../../../assets/images/logo.png").default}" alt="" />
        </a>
      </div>
      <div class="center">
      <!--
      <div
      class="navigation-link has-caret"
      data-x-on:mouseover="megamenuOpened = true, openedMegamenu = 'megamenu-2'"
      
    >
      <a class="is-flex is-align-items-center">
        <span>Explore</span>
        ${feather.icons["chevron-down"].toSvg()}
      </a>
    </div> -->

        <div
          class="navigation-link has-caret"
          data-x-on:mouseover="megamenuOpened = false, openedMegamenu = 'megamenu-1'"
          >
          <a href="https://personnel-connect.24telemed.org" class="is-flex is-align-items-center">
            <span></span>
            
          </a>
        </div>
       
        <div
          class="navigation-link has-caret"
          data-x-on:mouseover="megamenuOpened = false, openedMegamenu = 'megamenu-3'"
        >
          <a href="https://doctor-connect.24telemed.org" class="is-flex is-align-items-center">
            <span></span>
            
          </a>
        </div>
      

      
        
      </div>

 
  </div>
</div>

</div>




  <div
  class="megamenu "
  data-x-bind:class="{
    'is-active': megamenuOpened,
    '': !megamenuOpened,
  }"
>
  <!--Megamenu 0-->
  <div data-x-show="openedMegamenu === 'megamenu-0'" class="megamenu-inner">
    <button class="close-button" data-x-on:click="megamenuOpened = !megamenuOpened">
      <i data-feather="arrow-left"></i>
    </button>
    <div class="container">
      <div class="columns">
        <div class="column is-4">
          <div class="megamenu-block">
            <div class="media">
              <div class="media-left text-primary">
                <span class="fas fa-2x fa-user-nurse"></span>
              </div>
              <div class="media-content">
                <h3 class="text-rainbow">Nurses</h3>
                <p>
                  
                Connect with your patients around the globe. 
                  
                </p>
                
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block has-margin">
            <h4 class="text-rainbow">Links</h4>
            <ul>
              <li>
                <a href="${routers.dashboard.appointments}" class="arrow-link">
                  <span>Appointments</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
              <li>
                <a href="${routers.dashboard.patients}" class="arrow-link">
                  <span>My Patients</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
              <li>
                <a href="${routers.dashboard.chats}" class="arrow-link">
                  <span>Messages</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block is-left-bordered">
            <div class="media">
              <div class="media-content">
                <h3 class="text-rainbow">Account Profile</h3>
                <p>
                Set up your profile and connect with your patients around the globe. 
                </p>
                <a href="${routers.dashboard.profile}" class="arrow-link">
                  <span>Update Profile</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Megamenu 1-->
  <div data-x-show="openedMegamenu === 'megamenu-1'" class="megamenu-inner">
    <button class="close-button" data-x-on:click="megamenuOpened = !megamenuOpened">
      <i data-feather="arrow-left"></i>
    </button>
    <div class="container">
      <div class="columns">
        <div class="column is-4">
          <div class="megamenu-block">
            <div class="media">
              <div class="media-left text-primary">
                <span class="fas fa-2x fa-hospital-user"></span>
              </div>
              <div class="media-content">
                <h3 class="text-rainbow">Patients</h3>
                <p>
                  
                  Connect with your doctor from the comfort of your home.
                  
                </p>
                
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block has-margin">
            <h4 class="text-rainbow">Links</h4>
            <ul>
              <li>
                <a href="${routers.dashboard.appointments}" class="arrow-link">
                  <span>Appointments</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
              <li>
                <a href="${routers.dashboard.favourites}" class="arrow-link">
                  <span>My Favourites</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
              <li>
                <a href="${routers.dashboard.chats}" class="arrow-link">
                  <span>Messages</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block is-left-bordered">
            <div class="media">
              <div class="media-content">
                <h3 class="text-rainbow">Medical Record</h3>
                <p>
                Upload your medical records for your doctor to get you the optimal healthcare you need.
                </p>
                <a href="${routers.dashboard.medicalrecord}" class="arrow-link">
                  <span>Update Record</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Megamenu 2-->
  <div data-x-show="openedMegamenu === 'megamenu-2'" class="megamenu-inner">
    <button class="close-button" data-x-on:click="megamenuOpened = !megamenuOpened">
      <i data-feather="arrow-left"></i>
    </button>
    <div class="container">
      <div class="columns">
        <div class="column is-4">
          <div class="megamenu-block">
            <div class="media">
              <div class="media-left text-primary">
                <span class="fas fa-2x fa-search"></span>
              </div>
              <div class="media-content">
                <h3 class="text-rainbow">Explore eClinic</h3>
                <p>
                  Explore a wide variety of our professional medical
                  specialists.
                </p>
                <a href="${routers.pages.search()}" class="arrow-link">
                  <span>Explore search engine</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block has-margin">
            <h4 class="text-rainbow">Popular Categories</h4>
            <div id="explore-mega-menu-categories" class="tags">
              
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="megamenu-block is-left-bordered">
            <div class="media">
              <div class="media-content">
                <h3 class="text-rainbow">Try our specialists</h3>
                <p>
                  Not the adventurer type? Discover dozens of luxury trips in a
                  wide selection of locations.
                </p>
                <a href="${routers.pages.search()}" class="arrow-link">
                  <span>Explore now</span>
                  <i data-feather="arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Megamenu 3-->
  <div data-x-show="openedMegamenu === 'megamenu-3'" class="megamenu-inner">
    <button class="close-button" data-x-on:click="megamenuOpened = !megamenuOpened">
      <i data-feather="arrow-left"></i>
    </button>
   
    <div class="container">
    <div class="columns">
      <div class="column is-4">
        <div class="megamenu-block">
          <div class="media">
            <div class="media-left text-primary">
              <span class="fas fa-2x fa-user-md"></span>
            </div>
            <div class="media-content">
              <h3 class="text-rainbow">Doctors</h3>
              <p>
              Connect with your patients around the globe.
              </p>
              
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="megamenu-block has-margin">
          <h4 class="text-rainbow">Links</h4>
          <ul>
            <li>
              <a href="${routers.dashboard.appointments}" class="arrow-link">
                <span>Appointments</span>
                <i data-feather="arrow-right"></i>
              </a>
            </li>
            <li>
              <a href="${routers.dashboard.patients}" class="arrow-link">
                <span>My Patients</span>
                <i data-feather="arrow-right"></i>
              </a>
            </li>
            <li>
              <a href="${routers.dashboard.chats}" class="arrow-link">
                <span>Messages</span>
                <i data-feather="arrow-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-4">
        <div class="megamenu-block is-left-bordered">
          <div class="media">
            <div class="media-content">
              <h3 class="text-rainbow">Account Profile</h3>
              <p>
              Set up your profile and connect with your patients around the globe.
              </p>
              <a href="${routers.dashboard.profile}" class="arrow-link">
                <span>Update Profile</span>
                <i data-feather="arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
</div>
  

<!--Mobile Navbar-->
<div
class="mobile-main-navigation d-none" style="display: none;"
data-x-data="initNavbarMobile()"
data-x-on:scroll.window="scroll()"
data-x-bind:class="{
      'is-active is-scrolled': mobileSearchOpened,
      '': !mobileSearchOpened,
      'is-scrolled': scrolled,
      '': !scrolled,
  }"
>
<div class="mobile-main-navigation--inner">
  <div class="field">
    <div class="control has-icon">
      <input
        data-x-on:focus="toggleMobileSearch()"
        type="text"
        class="input is-rounded"
        placeholder="Where are you?"

      />
      <div class="form-icon">
      ${feather.icons.search.toSvg()}
      </div>
    </div>
  </div>
  <a
    href="${routers.pages.search()}"
    class="cancel-link"
    >Search</a
  >
</div>

<div class="mobile-main-navigation--location" style="display: none">
  <a class="near-link" data-x-on:click="toggleMobileSearchPanel()">
    <div class="near-icon">
      <i data-feather="map-pin"></i>
    </div>
    <span>Explore events near you</span>
  </a>
  <div class="near-tags">
    <h4>Places near you</h4>
    <div class="tags">
      <span class="tag">Los Angeles</span>
      <span class="tag">San Francisco</span>
      <span class="tag">San Diego</span>
      <span class="tag">Orange County</span>
      <span class="tag">San Juan</span>
    </div>
  </div>
  <div class="other-locations">
    <h4>Other places</h4>
    <div class="locations-group">
      <!--Item-->
      <div class="location-item">
        <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/events/carousel/19.jpg" alt="" />
        <div class="meta">
          <span>Marbella, Spain</span>
          <span>A great city with authenticity</span>
        </div>
      </div>
      <!--Item-->
      <div class="location-item">
        <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/events/carousel/20.jpg" alt="" />
        <div class="meta">
          <span>Fuengirola, Spain</span>
          <span>The best place for your holidays</span>
        </div>
      </div>
      <!--Item-->
      <div class="location-item">
        <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/events/carousel/21.jpg" alt="" />
        <div class="meta">
          <span>Torremolinos</span>
          <span>Ideal for families and children</span>
        </div>
      </div>
      <!--Item-->
      <div class="location-item">
        <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/events/carousel/22.jpg" alt="" />
        <div class="meta">
          <span>Malaga, Spain</span>
          <span>A big and living city</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="mobile-search-panel"
  data-x-bind:class="{
          'is-active': mobileSearchPanelOpened,
          '': !mobileSearchPanelOpened
      }"
>
  <div class="mobile-search-panel--inner">
    <div class="panel-header">
      <button class="close-button" data-x-on:click="toggleMobileSearchPanel()">
        <i data-feather="chevron-left"></i>
      </button>
    </div>
    <div class="panel-body">
      <div data-x-show.transition="activeWizardStep === 0" class="panel-step">
        <h3>What are you looking for?</h3>
        <div class="radio-cards-group">
          <!--Card-->
          <div class="radio-card">
            <input type="radio" name="topic_selection" checked />
            <div class="radio-card-inner">
              <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/thumbs/square/15.jpg" alt="" />
              <div class="meta">
                <span>Everything</span>
                <span>Everything that you can book on Listkit.</span>
              </div>
            </div>
          </div>
          <!--Card-->
          <div class="radio-card">
            <input type="radio" name="topic_selection" />
            <div class="radio-card-inner">
              <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/thumbs/square/7.jpg" alt="" />
              <div class="meta">
                <span>Events</span>
                <span>Events that you can search and book on listkit.</span>
              </div>
            </div>
          </div>
          <!--Card-->
          <div class="radio-card">
            <input type="radio" name="topic_selection" />
            <div class="radio-card-inner">
              <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/thumbs/square/18.jpg" alt="" />
              <div class="meta">
                <span>Trips</span>
                <span>Trips and travel formulas available on Listkit.</span>
              </div>
            </div>
          </div>
          <!--Card-->
          <div class="radio-card">
            <input type="radio" name="topic_selection" />
            <div class="radio-card-inner">
              <img src="https://dummyimage.com/150x150" data-demo-src="https://listkit.cssninja.io/img/photo/content/thumbs/square/13.jpg" alt="" />
              <div class="meta">
                <span>Specialists</span>
                <span>Flats and houses that you can rent on Listkit.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div data-x-show.transition="activeWizardStep === 1" class="panel-step">
        <h3>When should that start?</h3>

        <div class="mobile-dates is-relative">
          <div class="month-selector">
            <div class="months">
              <a class="month active">Oct</a>
              <a class="month">Nov</a>
              <a class="month">Dec</a>
              <a class="month">Jan</a>
            </div>
          </div>

          <div class="date-selector">
            <div class="date-box">
              <input type="radio" name="date_selection" checked />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>15</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>16</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>17</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>18</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>19</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>20</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>21</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>22</span>
              </div>
            </div>
            <div class="date-box">
              <input type="radio" name="date_selection" />
              <div class="date-box-inner">
                <div class="indicator">
                  <i class="fas fa-check"></i>
                </div>
                <span>Mon</span>
                <span>23</span>
              </div>
            </div>
          </div>

          <div class="my-4 has-text-centered">
            <a class="underlink">Load more dates</a>
          </div>
        </div>
      </div>

      <div data-x-show.transition="activeWizardStep === 2" class="panel-step">
        <h3>What type of audience?</h3>

        <div class="type-blocks">
          <div class="type-block">
            <div class="meta">
              <span>General audience</span>
              <span>Suitable for everyone</span>
            </div>
            <div class="action">
              <label class="form-switch is-primary">
                <input
                  type="radio"
                  name="search_type_radio_mobile"
                  class="is-switch"
                  checked
                />
                <i></i>
              </label>
            </div>
          </div>
          <div class="type-block">
            <div class="meta">
              <span>Family</span>
              <span>Suitable for kids and families</span>
            </div>
            <div class="action">
              <label class="form-switch is-primary">
                <input
                  type="radio"
                  name="search_type_radio_mobile"
                  class="is-switch"
                />
                <i></i>
              </label>
            </div>
          </div>
          <div class="type-block">
            <div class="meta">
              <span>Adults only</span>
              <span>Only for adults and grown ups</span>
            </div>
            <div class="action">
              <label class="form-switch is-primary">
                <input
                  type="radio"
                  name="search_type_radio_mobile"
                  class="is-switch"
                />
                <i></i>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Wizard Navigation Buttons-->
<div
  class="search-panel-buttons"
  data-x-bind:class="{
          'is-active': mobileSearchPanelOpened,
          '': !mobileSearchPanelOpened
      }"
>
  <div class="search-panel-buttons-inner">
    <button
      class="button h-button is-light is-bold"
      data-x-on:click="wizardBack($event)"
    >
      Previous
    </button>
    <button
      class="button h-button is-primary is-bold"
      data-x-on:click="wizardForward($event)"
    >
      Next
    </button>
  </div>
</div>
</div>
<div
class="mobile-sub-navigation"
data-x-data="initNavbarBottom()"
data-x-on:scroll.window="scroll()"
data-x-bind:class="{
      '': isBottomNavActive,
      'is-dismissed': !isBottomNavActive
  }"
>
<div class="mobile-sub-navigation--inner">
  <div class="sub-links">
    <a href="events.html" class="sub-link is-active">
      <div>
        <i data-feather="compass"></i>
        <span>Explore</span>
      </div>
    </a>
    <a data-x-show="$store.app.isLoggedIn === false" href="help-center.html" class="sub-link">
      <div>
        <i data-feather="life-buoy"></i>
        <span>Help</span>
      </div>
    </a>
    <a data-x-show="$store.app.isLoggedIn === false" href="login.html" class="sub-link">
      <div>
        <i data-feather="log-in"></i>
        <span>Sign In</span>
      </div>
    </a>
    <a data-x-show="$store.app.isLoggedIn === true" href="account-schedule.html" class="sub-link">
      <div>
        <i data-feather="calendar"></i>
        <span>Schedule</span>
      </div>
    </a>
    <a data-x-show="$store.app.isLoggedIn === true" href="account-main.html" class="sub-link">
      <div>
        <i data-feather="user"></i>
        <span>Account</span>
      </div>
    </a>
  </div>
</div>
</div>
`
  )
};
